/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { HexColorPicker } from 'react-colorful';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';

class Category extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isEditing: false,
            category: _.clone(props.category),
            showPicker: false
        };

        this.toggleControl = this.toggleControl.bind(this);
        this.handleColorUpdate = this.handleColorUpdate.bind(this);
        this.updateCategory = this.updateCategory.bind(this);
        this.deleteCategory = this.deleteCategory.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.cancelChange = this.cancelChange.bind(this);
        this.onKeyup = this.onKeyup.bind(this);

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.isEditing) {
            if (!_.isEqual(prevProps.category, this.props.category) && _.isEqual(this.props.category, this.state.category)) {
                this.setState({
                    isEditing: false
                });
            }
        }

    }

    toggleControl(e) {
        let control = e.currentTarget.dataset.control,
            state = this.state,
            newValue = (state[control]) ? false : true;

        state[control] = newValue;

        this.setState(state);

    }

    handleColorUpdate(color, e) {
        let category = this.state.category;

        category.color = color;

        this.setState({
            category
        });

    }

    updateCategory(e) {

        if (_.isEqual(this.state.category, this.props.category)) {
            this.setState({
                isEditing: false
            });
            return;
        }

        this.props.updateHandler(this.state.category);

    }

    cancelChange(e) {

        this.setState({
            category: _.clone(this.props.category),
            isEditing: false
        });

    }

    deleteCategory(e) {

        this.props.deleteHandler(this.state.category.id);

    }

    onInputChange(e) {

        let category = this.state.category,
            value = e.currentTarget.value;

        if (this.state.isEditing && value === '') {
            this.props.setValidationError(true);
        } else if (this.state.isEditing && value !== '') {
            this.props.setValidationError(false);
        }

        // doing this by hand because FormUtilityMixin was losing context
        // even trying the .apply(this, [e]) trick.
        category.name = value;

        this.setState({
            category
        });

    }

    onKeyup(e) {

        if (e.keyCode === 13) {
            this.updateCategory();
        }

    }

    render() {
        let category = null,
            picker = null,
            userHasAccess = this.props.userHasAccess,
            upgradeAction = this.props.upgradeAction;

        if (this.state.isEditing) {
            if (this.state.showPicker) {
                picker = (
                    <div className="popover">
                        <div className="picker-cover" onClick={this.toggleControl} data-control="showPicker" role="button" aria-label="show color picker"></div>
                        <HexColorPicker
                            color={this.state.category.color}
                            onChange={this.handleColorUpdate}
                            className="item-color-picker"/>
                    </div>

                );
            }
            return (
                <div className="category-item" data-pw="category">
                    <div
                        className="category-color-block"
                        style={{backgroundColor: this.state.category.color}}
                        onClick={(userHasAccess) ? this.toggleControl : upgradeAction}
                        data-control="showPicker"
                        role="button"
                        aria-label="show colors">
                    </div>
                    {picker}
                    <input
                        type="text"
                        className="text-input medium edit-category"
                        value={this.state.category.name}
                        onChange={(userHasAccess) ? this.onInputChange : upgradeAction}
                        onKeyUp={this.onKeyup}
                        data-field="category.name"
                        aria-label="Category name"/>
                    <div className="category-controls">
                        <i className="icon ion-checkmark-round" alt="save" title="save" onClick={(userHasAccess) ? this.updateCategory : upgradeAction} role="button" aria-label="save"></i>
                        <i className="icon ion-arrow-return-left" alt="cancel" title="cancel" onClick={this.cancelChange} role="button" aria-label="cancel"></i>
                        <i className="icon ion-ios-trash-outline" alt="delete" title="delete" onClick={this.deleteCategory} role="button" aria-label="delete"></i>
                    </div>
                </div>
            );
        }

        return (
            <div className="category-item" onClick={this.toggleControl} data-control="isEditing" role="button" aria-label={`edit ${this.state.category.name}`} data-pw="category">
                <div
                    className="category-color-block"
                    style={{backgroundColor: this.state.category.color}}
                    onClick={(userHasAccess) ? this.toggleControl : upgradeAction}
                    data-control="showPicker"
                    role="button"
                    aria-label="change color">
                </div>
                <div className="category-name">{this.state.category.name}</div>
                <Breakpoint mobile only>
                    <div className="mobile-edit-toggle">
                        <i className="icon ion-edit"></i>
                    </div>
                </Breakpoint>
            </div>
        );
    }
}

Category.propTypes = {
    category: PropTypes.object,
    updateHandler: PropTypes.func
};

Category.defaultProps = {
    category: {},
    updateHandler: () => {}
};

export default Category;
